module.exports = __webpack_public_path__ + "img/keysicon.8536e2a4.svg";